export const DEFAULT_INITIATOR = 'myyola';
